// extracted by mini-css-extract-plugin
export default {"stars":"RatingStars_stars__4cfM5","star":"RatingStars_star__iamsI","active":"RatingStars_active__A6bjo"};